"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProductPriceVariantValue = void 0;
const getProductPriceVariantValue = (variantSchema, variantKey, option) => {
    if (!variantSchema.includes(option))
        return '';
    const schemaOptions = variantSchema.split('/');
    const variantValues = variantKey.split('/');
    if (schemaOptions.length !== variantValues.length)
        return '';
    const optionIndex = schemaOptions.indexOf(option);
    if (optionIndex === -1)
        return '';
    return variantValues[optionIndex];
};
exports.getProductPriceVariantValue = getProductPriceVariantValue;
//# sourceMappingURL=getProductPriceVariantValue.js.map